import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchIcon from '@mui/icons-material/Search';

import { CardCamera } from '../../components/cardCamera/CardCamera'
import { InnerCameraModal } from '../../components/modalInnerCamera/innerCamera';
import { ContextApi } from '../../context/contextApi';
import { DrawerContext } from '../../context/drawerContext';
import { Header } from '../../components/header/Header';

import styles from './style.module.scss';
import { MenuOrderingContainer } from '../../components/menuOrdering/menuOrderingContainer';
import { AddVideosAnuncio } from '../../components/AdAnuncio/adAnuncio';
import { MenuOrderingEstadosByRegional } from '../../components/menuOrderingUf/menuOrderingEstadosByRegional';
import { MenuOrderingEstadosContainer } from '../../components/menuOrderingUf/menuOrderingEstadosContainer';

export function Home() {
    let navigate = useNavigate();
    const { 
      allCameras, 
      getCameras, 
      cookies, 
      getAllEstados,
    } = useContext(ContextApi)
    const {
      setShowInnerVideo,
      showInnerVideo,
      setShowMenuOrdering,
      showMenuOrdering,
      setShowUploadVideo,
      setVideoAnuncio,
      showMenuOrderingEstadosByRegional,
      showMenuOrderingEstados
    } = useContext(DrawerContext)
    const [inputSearch, setInputSearch] = useState('');
    const [openDrawer, setOpenDrawer] = useState(false);
    const [filterUf, setFilterUf] = useState('default');
    const [pagination, setPagination] = useState(12);

    function handleCloseMenuOrdering() {
      setShowMenuOrdering(false);
    }

    const ufAtuais = allCameras.map(uf => uf.estado)
    const ufUnique = [...new Set(ufAtuais)]

    function checkCredentials() {
        setTimeout(() => {
            if (!cookies?.surfViewToken?.token || cookies?.surfViewToken?.userRole === false) {
                navigate("/login")
            }       
        }, 2000);
    }

    useEffect(() => {
        checkCredentials()
    }, [])

    useEffect(() => {
        setTimeout(() => {
            if (cookies?.surfViewToken?.token) {
                getCameras() 
                getAllEstados()
            }
        }, 2000);
    }, [cookies])

    let filterThisState = allCameras.filter(ufSelect => {
        if (filterUf !== 'default') {
            return ufSelect.estado === filterUf
        } else {
            return ufSelect
        }
    })

    let cameraFilter = filterThisState.filter((data) => {
            let response;
            response = data.nome_camera.toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.cidade.toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.estado.toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.estado_sigla.toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.area_regiao.nome.toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.parceiro.toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.nome_camera.normalize("NFD").replace(/\p{Mn}/gu, "").toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.cidade.normalize("NFD").replace(/\p{Mn}/gu, "").toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.estado.normalize("NFD").replace(/\p{Mn}/gu, "").toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.estado_sigla.normalize("NFD").replace(/\p{Mn}/gu, "").toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.area_regiao.nome.normalize("NFD").replace(/\p{Mn}/gu, "").toLowerCase().includes(inputSearch.toLocaleLowerCase()) ||
            data.parceiro.normalize("NFD").replace(/\p{Mn}/gu, "").toLowerCase().includes(inputSearch.toLocaleLowerCase())
    
            return response
        })

    function handleCloseInnerVideo() {
        setShowInnerVideo(false);
        setShowUploadVideo(false);
        setVideoAnuncio('');
    }

    return (
        <>
            <Header 
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            />
            <div className={styles.containerHome}>
                <div className={styles.boxActionsHeader}>     
                    <div className={styles.contentSearch}>
                        <input 
                        type="text" 
                        onChange={(e) => setInputSearch(e.target.value)}
                        />
                        <SearchIcon />
                    </div>
                    <div className={styles.contentSearch}>
                        <select 
                        name='uf'
                        onChange={(e) => setFilterUf(e.target.value)}
                        >
                            <option value='default'>Filtrar por estado</option>
                            {ufUnique.map(uf => {
                                return (
                                    <option value={uf}>{uf}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <span>Exibindo {cameraFilter.length > pagination ? pagination : cameraFilter.length} de um total de {allCameras.length} câmeras</span>
                <div className={styles.boxCardCamera}>
                {cameraFilter.slice(0, pagination).map(item => {
                    return (
                        <CardCamera 
                        responseCameras={item}
                        />
                    )
                })}
                </div>
                <div className={styles.boxPagination}>
                    <span>Exibindo {cameraFilter.length > pagination ? pagination : cameraFilter.length} de um total de {allCameras.length} câmeras</span>
                    {cameraFilter.length > pagination &&
                    <div 
                    className={styles.BTNMoreResults}
                    onClick={() => setPagination(pagination + 12)}
                    >
                        <span>Exibir mais...</span>
                    </div>}
                </div>
                <InnerCameraModal />
                {showMenuOrderingEstadosByRegional && <MenuOrderingEstadosByRegional />}
            </div>
            <AddVideosAnuncio 
            showInnerVideo={showInnerVideo}
            handleCloseInnerVideo={handleCloseInnerVideo}
            />
            <MenuOrderingContainer 
            showMenuOrdering={showMenuOrdering}
            handleCloseMenuOrdering={handleCloseMenuOrdering}
            />
            {showMenuOrderingEstados && <MenuOrderingEstadosContainer />}
        </>
    )
}